/**
 * 9 周年庆活动 — 常量与时间轴配置
 * 时间轴（已确认）：9/22 预热（可看不可领）→ 9/24 签到开始 → 10/10 23:59 结束 → 10/12 12点开奖、13点停止自动弹窗 → 10/19 0点入口下线（图标换默认、烟花消失）
 */
export const IMG_BASE = '/image/home/anniversary'

/** 拼接切图地址（public/image/home/anniversary） */
export const img = (name: string) => `${IMG_BASE}/${name}`

/** 全量切图清单，打开弹窗前统一预加载，避免图片闪出 */
export const ANNIVERSARY_IMAGES = [
  'bj.png',
  'title.png',
  'code.png',
  'dg.png',
  'gfmk.png',
  'gqj.png',
  'gsdg.png',
  'jdjt.png',
  'jjqydj.png',
  'jqh.png',
  'jqq.png',
  'jqs.png',
  'jrjq.png',
  'jrvip.png',
  'kaijiang.png',
  'lw.png',
  'liwu.png',
  'mkbj.png',
  'gou.png',
  'vip.png',
  'wc.png',
  'yt.png',
  'zj.png',
  'znq.png',
  'zqj.png',
  'alpaca.png',
  '1.png',
  '2.png',
  '3.png'
].map(img)

/** 活动时间轴（毫秒时间戳）；'-'→'/' 兼容 Safari，'T'→' ' 必须同步替换，否则 '/'与'T' 混用会解析为 Invalid Date */
const t = (s: string) => new Date(s.replace(/-/g, '/').replace('T', ' ')).getTime()

export const ACTIVITY = {
  /** 预热开始 9/22 0点（可看不可领） */
  preheatStart: t('2026-09-22T00:00:00'),
  /** 签到正式开始 9/24 0点 */
  activeStart: t('2026-09-24T00:00:00'),
  /** 活动结束 10/10 23:59:59 */
  activeEnd: t('2026-10-10T23:59:59'),
  /** 开奖 10/12 12点 */
  lotteryTime: t('2026-10-12T12:00:00'),
  /** 停止自动弹窗 10/12 13点（开奖后1小时；写死节点，不根据后端状态判断） */
  autoPopupEndTime: t('2026-10-12T13:00:00'),
  /** 入口下线 10/19 0点（蛋糕/烟花隐藏、图标换回默认版；写死节点，不根据后端状态判断） */
  entryRemoveTime: t('2026-10-19T00:00:00'),
  /** 累计 VIP 奖励总天数（活动固定 14 格合计 23 天） */
  totalVipDays: 23
} as const

/** 活动阶段：未开始(<9/22) / 预热(9/22~9/23) / 进行中(9/24~10/10) / 已结束(10/11 起) */
export type ActivityPhase = 'notStarted' | 'preheat' | 'active' | 'ended'

/** 节日登录礼开放日期（9/25、9/30、10/1）；未登录的日程弹窗仅这些日期展示节日引导卡片 */
export const FESTIVAL_DATE_KEYS = ['2026-09-25', '2026-09-30', '2026-10-01'] as const

/** 是否为节日登录礼日期（dateKey 为 yyyy-MM-dd） */
export const isFestivalDateKey = (dateKey: string) =>
  (FESTIVAL_DATE_KEYS as readonly string[]).includes(dateKey)

export function getActivityPhase(now = Date.now()): ActivityPhase {
  if (now < ACTIVITY.preheatStart) return 'notStarted'
  if (now < ACTIVITY.activeStart) return 'preheat'
  if (now <= ACTIVITY.activeEnd) return 'active'
  return 'ended'
}

/**
 * 活动是否已经开始（未开始 / 预热期间禁止领取）；
 * 活动结束后所有领取入口关闭：各模块按 phase=ended 与奖励自身 EXPIRED 状态展示已过期 / 隐藏领取按钮
 */
export const isActivityStarted = (phase: ActivityPhase) => phase === 'active' || phase === 'ended'

/** 活动规则与中奖公示为当前域名下的独立 H5 页面（/appPage/9th/rule/index.html），点击后新标签打开 */
export const PUBLICITY_URL = '/appPage/9th/rule/index.html'

/** 每天自动弹一次的 localStorage 标记 key（按天记录） */
export const AUTO_OPEN_KEY = 'anniv_9th_auto_open_date'

/** 北京时间当天日期标记 yyyy-MM-dd（可传入服务端校准后的时间戳，避免本机时间不准/测试时钟下判断错天） */
export const todayTag = (ts = Date.now()) => {
  const d = new Date(ts + 8 * 3600 * 1000)
  const p = (n: number) => `${n}`.padStart(2, '0')
  return `${d.getUTCFullYear()}-${p(d.getUTCMonth() + 1)}-${p(d.getUTCDate())}`
}
